import { render, staticRenderFns } from "./RegistrationPersonalConfirm.vue?vue&type=template&id=4ccf216f&scoped=true&"
import script from "./RegistrationPersonalConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationPersonalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPersonalConfirm.vue?vue&type=style&index=0&id=4ccf216f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf216f",
  null
  
)

export default component.exports